// حساب إجماليات أمر الشراء الحية — يدعم اثنين اتجاهيًا للخصم والضريبة.
const num = (v) => { const n = parseFloat(v); return isFinite(n) ? n : 0; };

export const calcTotals = (lines, head) => {
  const subtotal = lines.reduce((s, l) => s + num(l.quantity) * num(l.unit_price), 0);
  const dAmt = num(head.discount_amount);
  const dPct = num(head.discount_percent);
  const discount = dAmt > 0 ? dAmt : (dPct > 0 ? (subtotal * dPct) / 100 : 0);
  const afterDiscount = Math.max(subtotal - discount, 0);
  const tAmt = num(head.tax_amount);
  const tPct = head.tax_percent != null && head.tax_percent !== ""
    ? num(head.tax_percent) : 0;
  const tax = tAmt > 0 ? tAmt : (afterDiscount * tPct) / 100;
  return { subtotal, discount, afterDiscount, taxPct: tPct, tax, grand: afterDiscount + tax };
};
